import React from "react";
import ReactDOM from "react-dom";
import Main from "./containers/Main";
import "./i18n";

ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
  document.getElementById("root")
);
